import { useEffect, useState } from 'react';

import { Bit } from '../../style-system/factory';
import { XCloseIcon } from '../icon/icons';
import { IconButton } from '../icon-button';

import { clickableProseImageStyles, proseImgModalStyles } from './prose-img.styles'; // Assuming you have styles defined for modal

type ProseImgProps = {
    src?: string;
    alt?: string;
    onClose: () => void;
    /**
     * Controls whether the image colors will invert in light mode.
     * If `false` or `undefined` images will invert in dark mode.
     */
    invertInLightMode?: boolean;
};

const ModalImg = ({ src, alt, onClose, invertInLightMode = false }: ProseImgProps) => {
    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                onClose();
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    const { base, image, content, close } = proseImgModalStyles();

    return (
        <div className={base()} onKeyDown={() => null} onClick={onClose}>
            <div className={close()}>
                <IconButton icon={XCloseIcon} onClick={onClose} aria-label={'Close modal'} />
            </div>
            <div className={content()}>
                <Bit.img src={src} alt={alt} className={image({ invertInLightMode })} />
            </div>
        </div>
    );
};

const ProseImg = ({ src, alt, invertInLightMode = false }: Omit<ProseImgProps, 'onClose'>) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleImageClick = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    return (
        <>
            <Bit.a onClick={handleImageClick} onKeyDown={() => null}>
                <Bit.img src={src} alt={alt} className={clickableProseImageStyles({ invertInLightMode })} />
            </Bit.a>
            {isModalOpen && (
                <ModalImg src={src} alt={alt} onClose={handleCloseModal} invertInLightMode={invertInLightMode} />
            )}
        </>
    );
};

export type { ProseImgProps };
export { ProseImg };
